export const useTopLeftDisplayStore = definePiniaStore('topLeftDisplay', () => {
    const value = ref('')
    
    return {
        value
    }
})
